const agencyBilling = '/account/billing';
const agencyBillingCreditCard = `${agencyBilling}/credit-card`;

/*
 * This is a step towards consolidating the link generation for app notices
 * The notices in app-notice-message that are not included in this file
 * either have query params, multiple links, or some other logic that
 * needs to be addressed.
 *
 * All of these links are added to the app notice card and override
 * any links that are included in the notice message.
 *
 * As a pattern, simple angular routes should be included here if the app notice
 * message does Not have any links.
 */

export const appNoticeLinks = {
  account_disabled: agencyBillingCreditCard,
  trial: agencyBillingCreditCard,
  trial_pending: agencyBillingCreditCard,
  billing: agencyBillingCreditCard,
  manual_invoice_late: agencyBilling,
  form_capture_limit: agencyBilling,
  account_closing: '/account/reactivate',
  forms_legacy_upgrade_required: agencyBilling,
  forms_lite_upgrade_required: agencyBilling,
  no_forms_product: agencyBilling,
  annual_plans_reminder: agencyBilling,
  redundant_plans: agencyBilling,
};
